<template>
  <b-row>
    <b-col>
      <b-card>
        <div slot="header">
          <b-row>
            <b-col md="6" class="d-flex align-items-center">
              <span v-if="showCheckbox">{{ $lang.select }}</span>
              <strong class="px-1">{{ title }}</strong>
              <b
                class="badge badge-pill badge-primary fontSize-15 ml-1"
                v-if="choosed.length"
              >
                {{ choosed.length }}</b
              >
            </b-col>
            <b-col md="6">
              <div class="float-right">
                <slot name="buttons" />
                <b-button-group>
                  <b-button
                    v-if="allowCommunityUnity"
                    :pressed="exercise_filter_type === 'community'"
                    variant="outline-primary"
                    v-b-tooltip.hover
                    :title="$lang.caseCommunityTooltip"
                    v-text="$lang.caseCommunity"
                    @click="getExerciseType('community')"
                  />
                  <b-button
                    v-if="allowCommunityUnity"
                    :pressed="exercise_filter_type === 'unity'"
                    variant="outline-primary"
                    v-b-tooltip.hover
                    :title="$lang.caseUnityTooltip"
                    v-text="$lang.caseUnity"
                    @click="getExerciseType('unity')"
                  />
                </b-button-group>

                <button
                  type="button"
                  class="btn btn-lightgray mx-2 position-relative"
                  v-if="filterheaders.length > 0"
                  @click="showFilter"
                >
                  <span
                    class="badge badge-pill badge-danger position-badge"
                    v-if="filterUrlLenght()"
                    >{{ filterUrlLenght() }}</span
                  >
                  <i class="fa fa-filter"></i>
                </button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-collapse
          id="CollapseSelectSearch"
          v-model="isCollapsed"
          class="mt-2"
        >
          <b-form-group v-show="visibleSearch">
            <b-input-group>
              <b-form-input
                type="text"
                v-model="inputSearch"
                :placeholder="$lang.search.place_holder"
                @keydown.enter="getItems"
              ></b-form-input>
              <b-input-group-prepend>
                <b-button
                  @click="getItems"
                  variant="primary"
                  v-b-tooltip.hover
                  :title="$lang.search.search_tooltip"
                >
                  <i class="fa fa-search"></i>
                </b-button>
              </b-input-group-prepend>
            </b-input-group>
          </b-form-group>
        </b-collapse>
        <b-row class="min-height">
          <b-col v-show="filter" :class="classFilter">
            <b-overlay :show="loadingItem" rounded="sm">
              <AdvanceFilter
                ref="advanceFilter"
                :headers="filterheaders"
                @getFilterItems="getFilterItems"
                @getFilterDate="getFilterDate"
                @closeAdvanceFilter="showFilter"
              />
            </b-overlay>
          </b-col>
          <b-col :class="classData">
            <div class="d-flex justify-content-center">
              <div class="text-center" v-show="loadingItem || isLoading">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </div>
              <h5 v-if="!loadingItem && !items.length">{{ noData }}</h5>
            </div>
            <div>
              <TableCheckBox
                :showCheckbox="showCheckbox"
                :table-data="items"
                :fields="availableColumns"
                :striped="true"
                bordered
                caption="<i class='fa fa-align-justify'></i> Bordered Table"
                :remove="remove"
                :modify="editItem"
                v-show="!loadingItem && !isLoading"
                :changePage="changePage"
                :currentPage="page"
                :totalPages="totalPages"
                :perPage="viewCount"
                :totalRows="totalRows"
                :editable="editable"
                :removable="removable"
                :toggleable="toggleable"
                :toggle="toggle_item"
                @row-clicked="clicked"
              />
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-modal
      :title="$lang.search.columns_setting"
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="filterModal"
      ok-only
      @ok="doFilter"
      :ok-title="$lang.submitButton"
    >
      <p>{{ $lang.search.columns_setting_hint }}</p>
      <b-form-group>
        <b-form-checkbox
          v-model="filterAllSelected"
          :indeterminate="indeterminate"
          aria-describedby="flavours"
          aria-controls="flavours"
          @change="toggleAllFilters"
          size="lg"
        >
          {{
            filterAllSelected
              ? $lang.search.all_deselect
              : $lang.search.all_select
          }}</b-form-checkbox
        >
        <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="filterSelected"
          name="flavour-1"
          stacked
          class="pull-right ml-2 col-md-12"
          cols="6"
          size="lg"
        >
          <Draggable
            v-model="columns"
            group="people"
            @start="drag = true"
            @end="drag = false"
            @change="updateSortedColumn"
            tags="ul"
            ghost-class="moving-column"
          >
            <div
              v-bind:key="index"
              v-for="(column, index) in columns"
              name="checkbox-1"
              class="mb-1 pl-1 flex justify-between items-center bg-white shadow rounded-lg cursor-move"
            >
              <b-form-checkbox :value="column.label" class>
                <span class="m-1">{{ column.label }}</span>
              </b-form-checkbox>
            </div>
          </Draggable>
        </b-form-checkbox-group>
      </b-form-group>
    </b-modal>
    <b-modal
      :title="$lang.search.delete_modal_title"
      header-bg-variant="danger"
      v-model="deleteModal"
      :ok-title="$lang.search.delete_modal_ok"
      ok-variant="danger"
      :cancel-title="$lang.search.delete_modal_cancel"
      cancel-variant="success"
      @cancel="!deleteModal"
      @ok="removing"
      :size="removeModalSize"
    >
      <p>{{ $lang.search.delete_modal_description }}</p>
      <TableCheckBox
        :table-data="[confirmRemoveItem]"
        :fields="availableColumns.slice(0, availableColumns.length - 1)"
        :striped="true"
        bordered
        caption="<i class='fa fa-align-justify'></i> Bordered Table"
        :readOnly="true"
        :allowPaginate="false"
        :allowRow="false"
      />
    </b-modal>
    <b-modal
      title
      v-model="addModal"
      hide-footer
      hide-header
      header-bg-variant="success"
      content-class="border-success"
      v-on:modal-end-up="handleAddModal"
      :size="addModalSize"
    >
      <slot name="addModal" :close="handleAddModal"></slot>
    </b-modal>
  </b-row>
</template>
<script>
import TableCheckBox from "./TableCheckBox";
import Draggable from "vuedraggable";
import AdvanceFilter from "@/components/base/advanceFilter";

export default {
  name: "select-search",
  components: {
    TableCheckBox,
    AdvanceFilter,
    Draggable,
  },
  props: {
    allowFilter: {
      type: Boolean,
      default: false,
    },
    primaryKey: {
      type: String,
      default: "id",
    },
    params: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    limitOneSelect: {
      type: Boolean,
      default: false,
    },
    maxSelectNumber: {
      type: Number,
      default: -1,
    },
    allowRemove: {
      type: Boolean,
      default: true,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
    choosedUrl: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    remove_item: {
      type: Function,
    },
    toggle_item: {
      type: Function,
    },
    edit_item: {
      type: Function,
    },
    config: {
      type: String,
      default: "",
    },
    query: {
      type: String,
      default: "",
    },
    toggleable: {
      type: Boolean,
      default: false,
    },
    addModalSize: {
      type: String,
      default: "md",
    },
    removeModalSize: {
      type: String,
      default: "md",
    },
    visibleSearch: {
      type: Boolean,
      default: true,
    },
    visibleSettings: {
      type: Boolean,
      default: false,
    },
    visibleExport: {
      type: Boolean,
      default: false,
    },
    visibleViewCount: {
      type: Boolean,
      default: false,
    },
    visibleFilters: {
      type: Boolean,
      default: false,
    },
    visibleAdd: {
      type: Boolean,
      default: false,
    },
    order_by: {
      type: String,
      default: "",
    },
    allowFields: {
      type: Object,
      default() {
        return {};
      },
    },
    // فیلد‌هایی که در نمایش جدول نباید نمایش داده شود
    disAllowFields: {
      type: Array,
      default() {
        return ["is_enable"];
      },
    },
    allowCommunityUnity: {
      type: Boolean,
      default: false,
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    viewCount: {
      type: [Number, String],
      default: 5,
    },
  },
  data() {
    return {
      loadingItem: false,
      isCollapsed: false,
      items: [],
      inputSearch: "",
      width: 800,
      myArray: [],
      drag: true,
      columns: [],
      noData: null,
      indeterminate: false,
      viewCountList: [5, 10, 20, 50, 100],
      perPage: 0,
      totalPages: 0,
      totalRows: 0,
      page: 1,
      buttons: [],
      buttonsAvailable: [],
      deleteModal: false,
      addModal: false,
      confirmRemoveItem: null,
      editable: false,
      removable: false,
      sortedColumns: [],
      choosed: this.value,
      exercise_filter_type: "community",
      filterModal: false,
      filterSelected: [],
      filterAllSelected: false,
      filter: false,
      classFilter: "",
      classData: "col-12",
      filterheaders: [],
      filterItems: {},
      paramsPage: {},
      filterUrl: "",
    };
  },
  methods: {
    showFilter() {
      this.filter = !this.filter;
      if (this.filter) {
        this.classFilter = "col-12 col-md-2";
        this.classData = "col-12 col-md-10";
      } else {
        this.classFilter = "";
        this.classData = "col-12";
      }
    },
    getFilterItems(value, key) {
      if (
        (typeof value == "string" || typeof value == "number") &&
        value !== ""
      ) {
        this.paramsPage[key] = value;
      } else if (typeof value == "object" && value.length > 0) {
        this.paramsPage[key] = value;
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.page = 1;
      this.getItems();
    },
    getFilterDate(key, type, value_from, value_to) {
      if (value_from) {
        this.paramsPage[key] = [type, value_from];
      } else if (value_to && value_from) {
        this.paramsPage[key] = [type, value_from, value_to];
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.page = 1;
      this.getItems();
    },
    filterUrlLenght() {
      if (this.filterUrl) {
        let count = this.filterUrl.split("=");
        return count.length - 1;
      }
      if (this.inputSearch) {
        return "1";
      }
    },
    async getFilter(key) {
      try {
        const keyFilterName = pathOr(null, ["key_filter_name"], key);
        if (
          !this.filterItems[keyFilterName] &&
          key.key_service !== "search_txt"
        ) {
          const url = generateApiUrl(["resources", "filter"], [keyFilterName]);
          const response = await this.$httpService.get(url);
          const items = pathOr([], ["data", "data"], response);
          if (items.length && items) {
            this.filterItems[keyFilterName] = items;
          }
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    getExerciseType(type) {
      this.exercise_filter_type = type;
      this.getItems();
    },
    sortClick() {
      this.items.sort(function (x, y) {
        return x.row === y.row ? 0 : x.row ? -1 : 1;
      });
    },
    clicked(item) {
      this.$emit("itemSelected", item, item.row);
      if (this.limitOneSelect) {
        this.choosed = item.row ? [item] : [];
        this.items = this.items.map((it) => {
          if (it[this.primaryKey] != item[this.primaryKey]) {
            it.row = false;
          }
          return it;
        });
      } else if (!item.row) {
        this.choosed = this.choosed.filter(
          (x) => x[this.primaryKey] != item[this.primaryKey]
        );
      } else {
        if (
          this.maxSelectNumber == -1 ||
          this.choosed.length + 1 <= this.maxSelectNumber
        ) {
          this.choosed.push(item);
        } else {
          item.row = !item.row;
        }
      }
      this.$emit("input", this.choosed);
      this.fetchItems(this.items);
    },

    removing() {
      this.loadingItem = true;
      return this.$httpService
        .delete(this.url + "/" + this.confirmRemoveItem[this.primaryKey])
        .then((response) => {
          this.$notify.success(response.data.message);
          this.getItems();
        })
        .catch((error) => {
          this.$generateError(error);
          this.loadingItem = false;
        });
    },
    handleAddModal() {
      this.addModal = !this.addModal;
      this.getItems();
    },
    fillChoosed() {
      this.loadingItem = true;
      this.columns = [];
      this.updateConfig();

      let url = this.choosedUrl;
      url += "?per_page=-1";
      return this.$httpService
        .get(url)
        .then((response) => {
          if ("result" in response.data.data || response.data.data) {
            let items = response.data.data.result || response.data.data;
            if (!items) {
              this.items = [];
              this.loadingItem = false;
              return true;
            }

            this.totalRows = response.data.data.total;
            if (items.length) {
              //use allow field from outside
              if (Object.keys(this.allowFields).length !== 0) {
                this.columns = Object.keys(this.allowFields).map((item) => {
                  return {
                    label: this.allowFields[item],
                    key: item,
                    sortable: true,
                  };
                });
              } else {
                // extract field from api
                Object.keys(items[0]).map((item) => {
                  if (item in this.$lang) {
                    this.columns.push({
                      label: this.$lang[item],
                      key: item,
                      sortable: true,
                    });
                  }
                });
              }
              items = items.map((item, index) => {
                Object.keys(item).map((v) => {
                  if (item[v] && Array.isArray(item[v])) {
                    item[v] = item[v]
                      .map((value, idx) => {
                        return this.extractValue(item[v], idx);
                      })
                      .join("، ");
                  } else {
                    item[v] = this.extractValue(item, v);
                  }
                });
                // item.row = index + 1;
                item.row =
                  this.choosed.filter(
                    (x) => x[this.primaryKey] == item[this.primaryKey]
                  ).length > 0
                    ? true
                    : false;
                return item;
              });
              this.choosed = items;
            } else {
              this.choosed = [];
            }

            this.loadingItem = false;
            return true;
          } else {
            this.choosed = [];
            this.loadingItem = false;
            return true;
          }
        })
        .catch((error) => {
          this.$generateError(error);
          throw error;
        });
    },
    doFilter() {
      this.filterModal = false;
    },
    toggleAllFilters(checked) {
      this.filterSelected = checked
        ? this.columns.map(({ label }) => label).slice()
        : [];
    },
    updateSortedColumn() {
      this.filterSelected = this.columns.map((column) => {
        if (this.filterSelected.includes(column.label)) {
          return column.label;
        }
      });
      this.updateConfig;
    },
    updateConfig() {
      // save search config to vuex
      let config = {};
      config[this.config] = {
        page: this.page,
        inputSearch: this.inputSearch,
        viewCount: this.viewCount,
        filterSelected: this.filterSelected,
      };
    },
    extractValue(item, v) {
      if (item[v] && typeof item[v] === "object") {
        if ("jalali" in item[v]) {
          return item[v].jalali;
        } else if ("caption" in item[v]) {
          return item[v]["caption"];
        } else if ("name" in item[v]) {
          return item[v]["name"];
        } else if ("view_label" in item[v]) {
          return item[v].view_label ? item[v].view_label : "";
        }
      } else {
        return item[v];
      }
    },
    getItems() {
      this.loadingItem = true;
      this.columns = [];
      this.updateConfig();
      let url = this.url;
      let params = {
        ...this.paramsPage,
        ...this.params,
        per_page: this.viewCount,
      };
      if (this.allowFilter) {
        params.exercise_filter_type = this.exercise_filter_type;
      }
      return this.$httpService
        .get(url, params)
        .then((response) => {
          if ("result" in response.data.data || response.data.data) {
            let items = response.data.data.result || response.data.data;
            this.$emit("checkedItems", items);
            if (!items || items.length == 0) {
              this.items = [];
              this.noData = this.$lang.noData;
              this.loadingItem = false;
              return true;
            }

            this.totalRows = response.data.data.total;
            this.totalPages = response.data.data.total_pages;
            this.perPage = response.data.data.per_page;
            if (!this.filterheaders.length > 0) {
              this.filterheaders = response.data.filters.map((x) => {
                return {
                  key_filter_caption: x.key_filter_caption,
                  key_filter_name: x.key_filter_name,
                  key_service: x.key_service,
                  open: x.open,
                  type: x.type,
                  loader: !x.open,
                };
              });
              let data = [...this.filterheaders];
              for (const item of data) {
                if (item.open) {
                  this.getFilter(item);
                }
              }
            }
            if (items.length) {
              //use allow field from outside
              if (Object.keys(this.allowFields).length !== 0) {
                this.columns = Object.keys(this.allowFields).map((item) => {
                  return {
                    label: this.allowFields[item],
                    key: item,
                    sortable: true,
                  };
                });
              } else {
                // extract field from api
                Object.keys(items[0]).map((item) => {
                  if (
                    !this.disAllowFields ||
                    !this.disAllowFields.includes(item)
                  )
                    if (item in this.$lang) {
                      this.columns.push({
                        label: this.$lang[item],
                        key: item,
                        sortable: true,
                      });
                    }
                });
              }
              this.fetchItems(items);
              this.sortClick();
            } else {
              this.noData = this.$lang.noData;
              this.items = [];
            }

            this.loadingItem = false;
            return true;
          } else {
            this.items = [];
            this.loadingItem = false;
            return true;
          }
        })
        .catch((err) => {
          this.$generateError(error);
          throw err;
        });
    },
    fetchItems(items) {
      this.items = items.map((item, index) => {
        Object.keys(item).map((v) => {
          // برای نگهداری دیتای قبلی
          if (typeof item[v] === "object") {
            item[v.concat("_object")] = item[v];
          }
          if (item[v] && Array.isArray(item[v])) {
            item[v] = item[v]
              .map((value, idx) => {
                return this.extractValue(item[v], idx);
              })
              .join("، ");
          } else {
            if (
              !(this.allowFields && Object.keys(this.allowFields).length > 0)
            ) {
              item[v] = this.extractValue(item, v);
            }
          }
        });
        item.row = this.choosed.some(
          (x) => x[this.primaryKey] == item[this.primaryKey]
        );
        return item;
      });
    },
    fillTable() {
      return this.getItems();
    },
    remove(item) {
      this.confirmRemoveItem = item;
      this.deleteModal = true;
    },
    addItem() {
      this.addModal = true;
    },
    editItem(item) {
      if (this.edit_item) {
        this.edit_item();
      } else {
        this.$router.push("edit/" + item[this.primaryKey]);
      }
    },
    changePage(page) {
      this.page = page;
      this.paramsPage["page"] = page;
      this.getItems();
    },
    fetchData() {
      if (this.choosedUrl) {
        this.fillChoosed().then(() => {
          this.fillTable()
            .then(() => {
              this.filterSelected = this.columns.map(({ label }) => label);
            })
            .catch(() => {});
        });
      } else {
        this.fillTable()
          .then(() => {
            this.filterSelected = this.columns.map(({ label }) => label);
          })
          .catch(() => {});
      }
    },
  },
  watch: {
    filterSelected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.filterAllSelected = false;
      } else if (
        newVal.length === this.columns.map(({ label }) => label).slice().length
      ) {
        this.indeterminate = false;
        this.filterAllSelected = true;
      } else {
        this.indeterminate = true;
        this.filterAllSelected = false;
      }

      this.updateConfig();
    },
    viewCount() {
      this.fillTable();
    },
    buttons() {
      if (this.buttons) {
        this.editable =
          this.allowEdit &&
          (this.buttons.includes("edit") || this.buttons.includes("view"))
            ? true
            : false;
        this.removable = this.allowRemove && this.buttons.includes("admin");
      }
    },
  },
  computed: {
    availableColumns() {
      let cols = this.columns.map((column) => {
        if (!this.filterSelected.includes(column.label)) {
          column.thClass = "d-none";
          column.tdClass = "d-none";
          column.index = -1;
        } else {
          column.thClass = "";
          column.tdClass = "";

          column.index = this.filterSelected.indexOf(column.label) + 1;
        }
        return column;
      });

      let columns = [
        {
          label: "",
          key: "row",
          // width: 100,
          sortable: false,
          index: 0,
        },
        ...cols.sort((a, b) => a.index - b.index),
      ];

      return columns;
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
